import { Collection } from "@type-r/models";
import { asCurrency, asTimelessDate, Column, Columns, Flex } from "lqx-react";
import React from "react";
import { PaymentChange } from "../../api/paymentChange";
import { AssetTileStatusField, AssetTileField, AssetTileHeaderField, CheckboxColumn, FirstColumn, SecondColumn, TileContainer, useAssetTileClasses, EventsColumn } from "../../components/asset-section-styles";
import { DigiCheckbox, DigiTooltip, limitText } from "../../shared";
import { InblockedAssetsEventStatus } from "../inblocked-assets-event-status";
import { PaymentExternalSystems } from "./externalSystems";

export const PaymentTile = ($active, selected: Collection<PaymentChange>, selectAllAssets) => (({ data, index, style }) => {
    const paymentChange: PaymentChange = data.items[index];
    const classes = useAssetTileClasses({ isSelected: $active.value && $active.value.id === paymentChange.id });
    const $checked = selected ? selected.$includes(paymentChange) : null;

    const onPaymentClicked = payment => $active.set(payment);

    return (<>
        <div key={paymentChange.id} style={style} className={classes.root} onClick={() => onPaymentClicked(paymentChange)}>
            <TileContainer>
                <Columns>
                    {selectAllAssets.value &&
                        <CheckboxColumn>
                            <DigiCheckbox checked={true} disabled={true} />
                        </CheckboxColumn>
                    }
                    {$checked && !selectAllAssets.value &&
                        <CheckboxColumn>
                            <DigiCheckbox $checked={$checked} disabled={selectAllAssets.value} />
                        </CheckboxColumn>
                    }
                    <Column>
                        <Flex row>
                            <Columns>
                                <EventsColumn>
                                    <Flex row>
                                        <InblockedAssetsEventStatus externalSystems={PaymentExternalSystems} assetChange={paymentChange} />
                                    </Flex>
                                    <Flex row>
                                        {/* <>DummyCell</> */}
                                    </Flex>
                                </EventsColumn>
                                <FirstColumn>
                                    <Flex row>
                                        <AssetTileStatusField> {paymentChange.state.name}</AssetTileStatusField>
                                    </Flex>
                                    <Flex row>
                                        <AssetTileField>Value Date {asTimelessDate(paymentChange.assetPaymentDate)}</AssetTileField>
                                    </Flex>
                                </FirstColumn>
                                <SecondColumn>
                                    <DigiTooltip title={`${paymentChange.debtorBankAccount.payor.name} - ${paymentChange.creditorBankAccount.payee.name}`}>
                                        <AssetTileHeaderField >{limitText(paymentChange.debtorBankAccount.payor.name, 60)} - {limitText(paymentChange.creditorBankAccount.payee.name, 60)}</AssetTileHeaderField>
                                    </DigiTooltip>
                                    <Flex row>
                                        <AssetTileField>Amount {asCurrency(paymentChange.paymentAmount)} {paymentChange.currency}</AssetTileField>
                                    </Flex>
                                </SecondColumn>
                            </Columns>
                        </Flex>
                    </Column>
                </Columns>
            </TileContainer>
        </div >
    </>
    )
})
